import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-register-pending',
  templateUrl: './modal-register-pending.component.html',
  styleUrls: ['./modal-register-pending.component.css']
})
export class ModalRegisterPendingComponent implements OnInit {
  @Input() padre: string;
  @Input() titulo: string;
  @Input() texto: string;
  @Input() check: string;
  ruta: string;
  label: string;

  constructor( 
    public activeModal: NgbActiveModal,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.label = 'Volver';
    if(this.padre === 'agencia'){
      this.ruta = 'admin/'+(this.router.url.split('admin/')[1]);
      
    /*  var value = (this.router.url.split('#')[0]).split('/')[2]; 
      if(value === 'perfil-pendiente' || value === 'perfil'){
        this.ruta = 'admin/agencias-pendientes'
      } else {
        this.ruta = 'admin/'+(this.router.url.split('#')[0]).split('/')[2];
      }      */           
    } else if(this.padre === 'perfil'){
      this.ruta = 'user/perfil';          
    }  else {
      this.ruta = 'home';
      this.label = 'Volver a Inicio'    
    }    
  } 

}
